import "./style/index.css";
import App from "./components/app";

if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line global-require
  require("preact/debug");
}

export default App;
